import { useMemo } from 'react'
import { ILvl1Item, TreeItem, getChildren } from '../types'

const buildCountMap = (
  tree: ILvl1Item[],
  selectedIds: Set<string>,
): Map<string, number> => {
  const countMap = new Map<string, number>()
  if (selectedIds.size === 0) return countMap

  const traverse = (items: TreeItem[]): number => {
    let totalCount = 0

    for (const item of items) {
      const children = getChildren(item)
      let itemCount = 0

      if (children.length > 0) {
        const firstChild = children[0]
        if (firstChild && 'children' in firstChild) {
          itemCount = traverse(children)
        } else {
          itemCount = children.filter(child => selectedIds.has(child.id)).length
        }
      }

      if (itemCount > 0) {
        countMap.set(item.id, itemCount)
        totalCount += itemCount
      }
    }

    return totalCount
  }

  traverse(tree)
  return countMap
}

export const useSelectionCounts = (
  subjects: ILvl1Item[],
  axes: ILvl1Item[],
  pendingIds: Set<string>,
  activeTab: 'standards' | 'skills',
): Map<string, number> => {
  return useMemo(() => {
    const tree = activeTab === 'standards' ? subjects : axes
    return buildCountMap(tree, pendingIds)
  }, [subjects, axes, pendingIds, activeTab])
}
